
/**
 * Scoped Shadow-Open Patch for Shopify wallet buttons
 * Scope: ONLY inside #hvg-hidden-express-checkout-buttons
 */
(function scopedOpenShadowForHVG() {
  const CONTAINER_SELECTOR = '#hvg-hidden-express-checkout-buttons';
  const TARGETS = new Set([
    'shopify-accelerated-checkout-cart',
    'shopify-google-pay-button',
    'shopify-paypal-button',
    'shopify-apple-pay-button',
    'shop-pay-wallet-button'
  ]);

  const origAttachShadow = Element.prototype.attachShadow;
  const shadowRefs = new WeakMap();            
  let mountDepth = 0;                          

  function inContainer(el) {
    const container = document.querySelector(CONTAINER_SELECTOR);
    return !!(container && container.contains(el));
  }

  Element.prototype.attachShadow = function(init) {
    const tag = (this.tagName || '').toLowerCase();
    const isTarget = TARGETS.has(tag);

    if (isTarget) {
      const shouldForceOpen =
        (this.isConnected && inContainer(this)) || mountDepth > 0;

      if (shouldForceOpen) {
        const sr = origAttachShadow.call(this, { ...(init || {}), mode: 'open' });
        shadowRefs.set(this, sr);
        return sr;
      }
    }
    // default: bez zmian
    return origAttachShadow.call(this, init);
  };

  const wrapContainerInsertion = () => {
    const container = document.querySelector(CONTAINER_SELECTOR);
    if (!container || container.__hvgPatched) return;
    container.__hvgPatched = true;

    ['append', 'appendChild', 'insertBefore', 'replaceChildren', 'prepend'].forEach(fn => {
      const orig = container[fn];
      if (typeof orig !== 'function') return;
      container[fn] = function(...args) {
        try {
          mountDepth++;
          return orig.apply(this, args);
        } finally {
          mountDepth--;
        }
      };
    });
  };

  wrapContainerInsertion();
  document.addEventListener('DOMContentLoaded', wrapContainerInsertion);

  window.__hvgShadowRefs = shadowRefs;
})();
